enum AdvancedFilterTypes {
    All = 'All',
    Country = 'Country',
    HighestLevelOfEducation = 'HighestLevelOfEducation',
    FieldOfEducation = 'FieldOfEducation',
    JobType = 'JobType',
}

export default AdvancedFilterTypes;
